import 'core-js/stable'
import 'core-js/features/string/replace-all'
import 'regenerator-runtime/runtime'

import 'client/styles/main.global.css'
import 'client/styles/stripe.global.css'
import 'client/styles/typography.global.css'

import { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { Router, useLocation } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { loadableReady } from '@loadable/component'
import getPageRoute from 'routes/ssr/get-page-route'
import App from 'routes/ssr/App'
import createStore from 'client/lib/create-store'
import { setPageError } from 'client/store/ui/actions'
import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';

(function () {
  const _error = console.error.bind(console)

  console.error = function (...args) {
    if (args?.[0]?.isAxiosError) {
      console.error(args[0].toJSON())
      return
    }

    _error(...args)
  }
})()

//
// Add resizeobserverpolyfill if required.
//
// Loading asyncronously here is not always reliable,
// as sometimes the app will need a resize observer before
// we have loaded it.
//
if ('ResizeObserver' in window === false) {
  window.ResizeObserver = ResizeObserverPolyfill
}

export default function ScrollToTop () {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export const AppRouter = ({ history, store }) => (
  <Router history={history}>
    <ScrollToTop />
    <App store={store} />
  </Router>
)

loadableReady(async () => {
  const history = createBrowserHistory()
  const { page } = await getPageRoute(history.location.pathname)
  const initialAsyncReducers = page.default?.asyncStores || {}

  const initialStoreState = window.__SCITE_STORE_STATE
  const { store } = createStore(initialStoreState, history, initialAsyncReducers)
  history.listen((location, action) => {
    setTimeout(() => {
      const state = store.getState()
      if (state.ui.pageError) {
        store.dispatch(setPageError())
      }
    })
  })

  ReactDOM.hydrate(<AppRouter history={history} store={store} />, document.getElementById('scite-app'))
})
